import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Grid, CircularProgress } from '@material-ui/core/'
import { v4 as uuidv4 } from 'uuid'
import apiChat from '../../../../api/chat'
import UserContainer from './components/User/UserContainer'
import AvtorContainer from './components/Avtor'
import ChatInput from './components/ChatInput'
import DialogModal from './components/User/ModalMobile'
import c from 'classnames'
import './index.scss'

const CenterContainer = ({ loading, userMess, setUserMess, openUserMobileModal, setOpenUserMobileModal }) => {
  const [value, setValue] = useState('')
  const [text, setText] = useState('')
  const [deleteId, setDeleteId] = useState('')
  const [editTextMess, setEditTextMess] = useState('')
  const [isAvtor, setIsAvtor] = useState(false)
  const { chatUser } = useSelector(({ chat }) => chat)
  const { user } = useSelector(({ session }) => session)
  const chatClass = document.querySelector('.wrapperUserMessages')

  const onChange = e => {
    chatClass?.scrollTo(0, chatClass?.offsetHeight + 100000000)
    setValue(e.target.value)
  }

  const onSubmit = event => {
    if (text) {
      updateMessage()
    } else {
      if (value) {
        setUserMess(prev => [...prev, {
          text: value,
          thread: chatUser?.uuid,
          uuid: uuidv4(),
          from: user?.user?.uuid,
          status: 'sended',
          type: 'text',
          time: new Date(),
        }])
        setTimeout(() => {
          chatClass?.scrollTo(0, chatClass?.offsetHeight + 100000000)
        }, 500)
        setTimeout(() => {
          apiChat.sendNewMessage(user?.accessKey, {
            text: value,
            thread: chatUser?.uuid,
            uuid: uuidv4(),
          })
        }, 1000)
        setValue('')
      }
    }
  }

  const onCloseEdit = () => {
    setDeleteId('')
    setText('')
    setValue('')
    setEditTextMess('')
  }

  const updateMessage = () => {
    apiChat.editMessage(text, {
      accessKey: user?.accessKey,
      text: value,
    }).then(() => {
      setDeleteId('')
      setText('')
      setValue('')
      setEditTextMess('')
    })
  }

  useEffect(() => {
    if (chatUser?.authorUuid === user?.user?.uuid) {
      setIsAvtor(true)
    }
  }, [chatUser?.authorUuid])

  useEffect(() => {
    if (editTextMess) {
      setValue(editTextMess)
    }
  }, [editTextMess])

  return (
    <Grid className='centerContainerWrapper'>
      <DialogModal open={openUserMobileModal} onClose={() => setOpenUserMobileModal(false)} />
      {loading && <CircularProgress className='loadingMess' />}
      <Grid className={c('wrapperUserMessages', chatUser?.status === 'request' && 'updateUserMessages', +userMess?.length === 1 && 'centerContainerBack', isAvtor && 'newCenterContainerBack')}>
        {user?.user?.uuid === chatUser?.authorUuid ? (
          <AvtorContainer userMess={userMess} isAvtor={isAvtor} updateMessage={updateMessage} setText={setText} text={text} setEditTextMess={setEditTextMess} />
        ) : (
          <UserContainer
            userMess={userMess}
            setUserMess={setUserMess}
            setText={setText}
            text={text}
            deleteId={deleteId}
            setDeleteId={setDeleteId}
            setValue={setValue}
            updateMessage={updateMessage}
            setEditTextMess={setEditTextMess}
          />
        )}
      </Grid>
      {chatUser?.status !== 'request' && chatUser?.uuid && (
        <ChatInput
          onChange={onChange}
          value={value}
          onSubmit={onSubmit}
          editTextMess={editTextMess}
          onCloseEdit={onCloseEdit}
        />
      )}
    </Grid>
  )
}

export default CenterContainer
